export default __webpack_public_path__ + "static/media/DOGE-BNB-PCS.aa46baad.svg";